export const WWEX_API_CODE = 'speedship' as const;
export const UNISHIPPERS_API_CODE = 'unishippers' as const;

// Brand names — not translated, so plain constants rather than defineMessages entries.
export const WWEX_DISPLAY_NAME = 'Worldwide Express' as const;
export const UNISHIPPERS_DISPLAY_NAME = 'Unishippers' as const;

// LogRocket event properties use a stable slug independent of the backend apiCode.
export const getFreightProviderTrackingSlug = (apiCode: string): 'worldwide-express' | 'unishippers' | 'unknown' => {
  if (apiCode === WWEX_API_CODE) return 'worldwide-express';
  if (apiCode === UNISHIPPERS_API_CODE) return 'unishippers';
  return 'unknown';
};
